import FormModal from "../components/form/FormModal";
import {JsonArticleType} from "../generated-api";
import {FormProps} from "../model/form";
import {useAppTranslation} from "../services/i18n";
import EventArticleTypeForm from "../components/event/EventArticleTypeForm";

const EventArticleTypeModal = (props: FormProps<JsonArticleType>) => {

    const t = useAppTranslation();

    return (
        <FormModal title={props.item?.articleTypeId ? t('Úprava typu artiklu') : t('Nový typ artiklu')} {...props}>
            <EventArticleTypeForm {...props}></EventArticleTypeForm>
        </FormModal>
    );
}

export default EventArticleTypeModal;
